import React, { useState, useEffect, useMemo } from 'react';
import { GridComponent, ColumnsDirective, ColumnDirective, Page, Selection, Inject, Edit, Toolbar, Sort, Filter, Search } from '@syncfusion/ej2-react-grids';
import { Orden, DetalleOrdenVenta } from '../components';
import { Tabs, Tab, Select, MenuItem, useMediaQuery } from '@mui/material';
import axios from 'axios';
import { L10n } from '@syncfusion/ej2-base';

L10n.load({
  'es-ES': {
    grid: {
      Search: 'Buscar',
      EmptyRecord: 'No hay registros para mostrar',
    },
  },
});
const Ordenes = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [ordenes, setOrdenes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [ordenVisible, setOrdenVisible] = useState(false);
  const [detalleOrdenVisible, setDetalleOrdenVisible] = useState(false);
  const [selectedOrden, setSelectedOrden] = useState(null);
  const isMobile = useMediaQuery('(max-width: 768px)');
  const toolbarOptions = ['Search'];
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue); 
  };

  const TabWithIcon = ({ color, label }) => (
    <div
      style={{
        display: 'inline-block',
        backgroundColor: color,
        borderRadius: '12px',
        padding: '2px 8px',
        fontSize: '12px', // Tamaño más pequeño
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
        minWidth: '60px',
      }}
    >
      {label}
    </div>
  );


  const fetchOrdenesData = async () => {
    try {
      const token = localStorage.getItem('access_token');
      if (!token) {
        console.error('No se ha encontrado el token de autenticación.');
        return;
      }

      const config = { headers: { Authorization: `Bearer ${token}` } };

      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/ordenes-grid/`, config);
      const data = response.data.map((orden) => {
        let instalador = orden.instalador;
        let fechaInstalacion = orden.fecha_instalacion;
        if (orden.estado_orden === 'pendiente_asignar') {
          instalador = 'Pendiente asignar';
          fechaInstalacion = 'Pendiente calendarizar';
        } else if (orden.estado_orden === 'por_enviar') {
          instalador = 'N/A';
          fechaInstalacion = 'Pendiente calendarizar';
        } else {
          instalador = instalador || 'Pendiente asignar';
          fechaInstalacion = fechaInstalacion
            ? new Date(fechaInstalacion).toLocaleDateString()
            : 'Pendiente calendarizar';
        }
        return { ...orden, instalador, fecha_instalacion: fechaInstalacion };
      });

      setOrdenes(data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const refreshOrdenes = () => {
    fetchOrdenesData(); // Llama a la función que vuelve a cargar las órdenes
  };

  useEffect(() => {
    fetchOrdenesData();
  }, []);

  const filteredData = useMemo(() => {
    switch (selectedTab) {
      case 0: return ordenes.filter(item => item.estado_orden === 'pendiente_asignar');
      case 1: return ordenes.filter(item => item.estado_orden === 'por_enviar');
      case 2: return ordenes.filter(item => item.estado_orden === 'asignado');
      case 3: return ordenes.filter(item => item.estado_orden === 'enviado');
      case 4: return ordenes;
      default: return ordenes;
    }
  }, [ordenes, selectedTab]);

  const handleNewOrdenClick = () => {
    setOrdenVisible(true); // Mostrar el formulario de nueva orden de venta
  };

  const handleRowDoubleClick = (args) => {
    const ordenID = args.rowData.id_orden; // Aquí obtienes el ID de la cotización seleccionada
    setSelectedOrden(ordenID); // Guarda la orden seleccionada
    setDetalleOrdenVisible(true); // Mostrar el formulario de cotización al hacer doble clic en una fila
  };



  const campanaTemplate = (props) => {
    if (!props.campaign_info) return <span style={{ color: '#ccc' }}>—</span>;
    return (
      <span style={{ background: '#fff7ed', color: '#c2410c', border: '1px solid #fed7aa', borderRadius: 12, padding: '2px 8px', fontSize: 11, fontWeight: 700 }}>
        {props.campaign_info.codigo}
      </span>
    );
  };

  const handleRowClick = (args) => {
    const ordenID = args.data.id_orden; // Obtener el ID de la orden seleccionada
    setSelectedOrden(ordenID); // Guardar la orden seleccionada
    setDetalleOrdenVisible(true); // Mostrar el detalle de la orden
  };


  return (
    <div className="h-full flex flex-col p-2 md:p-4 overflow-hidden">
      <div className="flex-1 min-h-0 flex flex-col bg-white rounded-3xl p-2 md:p-3 overflow-hidden">
      <div className="flex justify-between items-center mb-2 flex-wrap gap-2">
        <p className="text-xl md:text-3xl font-extrabold tracking-tight text-slate-900">Órdenes de Venta</p>
        <div className="flex items-center gap-3">
          {isMobile ? (
            <Select value={selectedTab} onChange={(e) => setSelectedTab(e.target.value)} size="small" sx={{ minWidth: 150 }}>
              <MenuItem value={0}><TabWithIcon color="#FEC90F" label="Por Asignar" /></MenuItem>
              <MenuItem value={1}><TabWithIcon color="#FEC90F" label="Por Enviar" /></MenuItem>
              <MenuItem value={2}><TabWithIcon color="#8BE78B" label="Asignada" /></MenuItem>
              <MenuItem value={3}><TabWithIcon color="#8BE78B" label="Enviada" /></MenuItem>
              <MenuItem value={4}>Todas</MenuItem>
            </Select>
          ) : (
            <Tabs value={selectedTab} onChange={handleTabChange} scrollButtons="auto" variant="scrollable"
              sx={{
                '.MuiTab-root': { '&:hover': { color: '#FF743A' }, '&.Mui-selected': { color: '#FF743A' } },
                '.MuiTabs-indicator': { backgroundColor: '#FF743A' },
              }}
            >
              <Tab label={<TabWithIcon color="#FEC90F" label="Por Asignar" />} />
              <Tab label={<TabWithIcon color="#FEC90F" label="Por Enviar" />} />
              <Tab label={<TabWithIcon color="#8BE78B" label="Asignada" />} />
              <Tab label={<TabWithIcon color="#8BE78B" label="Enviada" />} />
              <Tab label="Todas" />
            </Tabs>
          )}
        </div>
      </div>
      
      {/* Renderizar formulario de nueva orden */}
      {ordenVisible && (
        <Orden
          onClose={() => setOrdenVisible(false)} // Pasar la función onClose a Orden
          cotizacionId = {filteredData.id_orden}
          refreshOrdenes={refreshOrdenes}  // Refrescar la lista de órdenes
        />
      )}

      {detalleOrdenVisible && selectedOrden && (
        <DetalleOrdenVenta
          onClose={() => setDetalleOrdenVisible(false)} // Pasar la función onClose a DetalleOrdenVenta
          ordenId={selectedOrden} // Pasar la orden seleccionada
          refreshOrdenes={refreshOrdenes}
        />
      )}

      {/* Grilla de órdenes de venta existentes */}
      <div className="flex-1 min-h-0 overflow-hidden mt-2">
      {loading ? (
        <div className="flex flex-col items-center justify-center h-full gap-3 text-gray-400">
          <div className="w-8 h-8 border-4 border-gray-200 border-t-orange-400 rounded-full animate-spin" />
          <p className="text-sm">Cargando órdenes...</p>
        </div>
      ) : (
      <GridComponent
        key={selectedTab}
        dataSource={filteredData}
        enableHover={false}
        height="100%"
        allowPaging
        pageSettings={{ pageCount: 5, pageSize: 15 }}
        selectionSettings={{ persistSelection: true, type: 'Single' }}  // Selección de filas individuales
        locale="es-ES"
        toolbar={toolbarOptions}
        editSettings={{ allowEditing: false, allowDeleting: false }}  // Desactivar la edición
        allowSorting
        sortSettings={{ columns: [{ field: 'id_orden', direction: 'Descending' }] }}  // Orden descendente por ID
        className="mt-4"
        //recordDoubleClick={handleRowDoubleClick}
        rowSelected={handleRowClick} // Detectar clic en una fila        
      >
        <ColumnsDirective>
          <ColumnDirective field="id_orden" headerText="ID" width="120" textAlign="Center" />
          <ColumnDirective field="solicitante_nombre_completo" headerText="Solicitante" width="200" textAlign="Center" />
          <ColumnDirective field="fecha_instalacion" headerText="Fecha Instalación" width="200" format="yMd" textAlign="Center" />
          <ColumnDirective field="estado_orden" headerText="Estado" width="150" textAlign="Center" />
          <ColumnDirective field="total_cotizacion" headerText="Total Cotización" width="150" format="C2" textAlign="Center" />
          <ColumnDirective headerText="Campaña" width="130" textAlign="Center" template={campanaTemplate} />
          <ColumnDirective field="direccion_instalacion" headerText="Dirección Instalación" width="200" textAlign="Center" />
          <ColumnDirective field="instalador" headerText="Instalador" width="150" textAlign="Center" />
        </ColumnsDirective>
        <Inject services={[Page, Selection, Toolbar, Edit, Sort, Filter, Search]} />
      </GridComponent>
      )}
      </div>
      </div>
    </div>
  );
};

export default Ordenes;
